import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Exchange } from "../../interface";

interface CoinselectedExchangeState {
  selectedExchange: Exchange | undefined;
}

const initialState: CoinselectedExchangeState = {
  selectedExchange: {
    partner_name: "",
    exchange_type: "",
    amount: undefined,
    min_amount: undefined,
    max_amount: undefined,
    tags: [],
  },
};

export const selectedExchangeSlice = createSlice({
  name: "selectedExchangeSlice",
  initialState,
  reducers: {
    setSelectedExchangeData: (
      state,
      action: PayloadAction<Exchange | undefined>
    ) => {
      state.selectedExchange = action.payload;
    },
  },
});

export const { setSelectedExchangeData } = selectedExchangeSlice.actions;

export default selectedExchangeSlice.reducer;
